import type { Movement } from "@services/movement-services/types";
import { getPastMovementServices } from "@services/movementServicesApi";
import { useQuery } from "@tanstack/react-query";

interface UsePastMovementsParams {
  service?: string;
  vesselCallId?: string;
  vesselId?: string;
  enabled?: boolean;
  page?: number;
  size?: number;
  staleTime?: number;
  refetchOnMount?: boolean;
  refetchOnWindowFocus?: boolean;
}

export const usePastMovements = ({
  service = "bff-vessel-call",
  vesselCallId,
  vesselId,
  enabled = true,
  page = 0,
  size = 25,
  staleTime,
  refetchOnMount,
  refetchOnWindowFocus,
}: UsePastMovementsParams) =>
  useQuery<{ items: Movement[]; totalElements: number } | undefined>({
    queryKey: ["getPastMovementServices", vesselCallId, vesselId, page, size, service],
    queryFn: () =>
      getPastMovementServices({
        service,
        vesselCallId: vesselCallId as string,
        vesselId: vesselId as string,
        page,
        size,
      }),
    enabled: !!vesselCallId && !!vesselId && enabled,
    ...(staleTime !== undefined && { staleTime }),
    ...(refetchOnMount !== undefined && { refetchOnMount }),
    ...(refetchOnWindowFocus !== undefined && { refetchOnWindowFocus }),
  });
